import React from 'react'
import { Button } from '@mui/material'
import { GridInfoStack } from 'components/atoms/InfoCard'
import { InfoCardIcon } from 'components/atoms/Icons'
import { useTranslation } from 'react-i18next'
import deeperConversationsIcon from 'assets/images/deeperConversations.svg'
import setupSuccessIcon from 'assets/images/setupSuccess.svg'
import highlightChallengesIcon from 'assets/images/highlightChallenges.svg'
import { AssessmentHeadWrapper } from 'components/molecules/assessments/AssessmentMolecules'
import { ColStack } from 'components/atoms/container/InCardStack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

const CheckInSurveyLanding = ({ handleBegin }) => {
  const { t } = useTranslation()

  return (
    <ColStack spacing={16}>
      <AssessmentHeadWrapper
        title={t('checkInSurvey.welcomeToYourPersonalizedOneOnOne')}
        description={t('checkInSurvey.everyConversationIsOpportunity')}>
        <GridInfoStack
          title={t('checkInSurvey.highlightChallenges')}
          content={t('checkInSurvey.highlightChallengesDesc')}
          icon={<InfoCardIcon src={highlightChallengesIcon} size={56} />}
        />
        <GridInfoStack
          title={t('checkInSurvey.sparkDeeperConversations')}
          content={t('checkInSurvey.sparkDeeperConversationsDesc')}
          icon={<InfoCardIcon src={deeperConversationsIcon} size={56} />}
        />
        <GridInfoStack
          title={t('checkInSurvey.setupForSuccess')}
          content={t('checkInSurvey.setupForSuccessDesc')}
          icon={<InfoCardIcon src={setupSuccessIcon} size={56} />}
        />
      </AssessmentHeadWrapper>

      <Button onClick={handleBegin} endIcon={<ArrowForwardIcon />}>
        {t('checkInSurvey.beginCheckin')}
      </Button>
    </ColStack>
  )
}

export default CheckInSurveyLanding
